<template>

    <div class="header-static-container">

        <div class="header-static">

            <img v-if="!isDesktop" class="foxy-static-head pointer" src="/img/logo/fox/blue-head-white.svg" @click="goLanding">

            <img v-if="isDesktop" class="logo-left pointer" src="/img/logo/large/white.svg" @click="goLanding">

        </div>

    </div>

</template>

<script>

    export default {

        name: 'header-static',

        computed: {

            isDesktop () {
                return this.$mq === 'lg'
            }

        },

        methods: {

            goLanding () {

                this.$router.push({ path: '/' })
            }
        }
    }

</script>

<style scoped lang="scss">

    .header-static-container {
        height: 56px;
        width: 100%;
        background-color: $blue;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .header-static {
        height: 100%;
        width: 100%;
        max-width: 1114px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 16px;
        @media screen and (min-width: $above-tablet-length) {
            justify-content: left;
        }
    }

    .logo-left {
        height: 40px;
        left: 16px;
    }

    .foxy-static-head {
        width: 40px;
        object-fit: contain;
    }


</style>
